import { IBrand } from "../../../../Models/IBrand";
import { IBrandOverviewTableRecord } from "../../../../Models/IBrandOverviewTableRecord";
import { IBrandSummaryData } from "../../../../Models/IBrandSummaryData";
import {
    IRetailMatchJobResult,
    IStoreScoreRecord
} from "../../../../Models/IRetailMatch";

export const MAX_BRAND_COUNT_OPTIMIZATION_MODE = 100;
export const TOO_FEW_RECORD_EXPLANATION
  = "Not enough consumer information was available for this brand's sample set to provide a detailed analysis.";

export const pathPrefix = (pathname: string): string => {
    const arr = pathname.split("/");
    return arr[1] === "retailMatch"
        ? "/retailMatch"
        : "/Reports/match";
};

export const brandLinkURL = (pathname: string, isSharing: boolean, jobId: string, brandId: string): string => {
    return isSharing 
        ? `/${brandId}` 
        : `${pathPrefix(pathname)}/${jobId}/${brandId}`;
};

export const overviewLinkURL = (pathname: string, isSharing: boolean, jobId: string): string => {
    return isSharing 
        ? `/` 
        : `${pathPrefix(pathname)}/${jobId}`;
};

export const brandStores = (stores: IStoreScoreRecord[], brandId: string): IStoreScoreRecord[] => {
    return stores.filter((store) => {
        return store.bid === brandId;
    });
};

export const getBrandSummaryData = (
    brand: IBrand,
    jobResult: IRetailMatchJobResult
): IBrandSummaryData => {
    const brandOverviewRecord = jobResult.chartData.overview.find(
        (overviewRecord) => overviewRecord.brandId === brand.brandId
    );

    const cvRollup = jobResult.chartData.brandConsumerViewRollups?.find(
        (cv) => cv.id === brandOverviewRecord?.brandId
    );

    return {
        overview: brandOverviewRecord,
        brand: brand,
        tooFewRecords: cvRollup ? false : true,
    };
};

export const rankTableSort = (a: IBrandOverviewTableRecord, b: IBrandOverviewTableRecord): number => {
    const aRank = a.brandSummary.overview?.rank || 99;
    const bRank = b.brandSummary.overview?.rank || 99;
    return aRank - bRank;
};

export const rankDataSort = (a: IBrandSummaryData, b: IBrandSummaryData): number => {
    const aRank = a.overview?.rank || 99;
    const bRank = b.overview?.rank || 99;
    return aRank - bRank;
};
